import { render, staticRenderFns } from "./BoilingFrog.vue?vue&type=template&id=6ac5b30c&"
import script from "./BoilingFrog.vue?vue&type=script&lang=js&"
export * from "./BoilingFrog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports